import React, { ReactElement, useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { CognitoUser } from '@aws-amplify/auth';
import { useHistory } from 'react-router-dom';
import { signOut, getProfile } from '../../utils/auth-functions';
import CardHeader from '../organisms/CardHeader';
import useRedirectUrl from '../../hooks/useRedirectUrl';
import useReturnUrl from '../../hooks/useReturnUrl';
import { GaAnalytics } from '../../utils/analytics';

export interface CognitoUserAttributes {
  name?: string;
  family_name?: string;
  nickname?: string;
}

type CustomCognitoUser = CognitoUser & { attributes: CognitoUserAttributes };

export default function Logout(): ReactElement {
  const [profile, setProfile] = useState<CustomCognitoUser | string | undefined>(undefined);
  const history = useHistory();
  const redirectUrl = useRedirectUrl();
  const returnUrl = useReturnUrl();

  const getLeaverUrl = () => {
    return redirectUrl || returnUrl;
  };

  useEffect(() => {
    const getProfileData = async () => {
      await getProfile().then((res) => setProfile(res));
    };
    getProfileData();
  }, []);

  useEffect(() => {
    if (profile && profile === 'The user is not authenticated') {
      history.replace(redirectUrl ? `/login?redirectUrl=${redirectUrl}` : '/login');
    }
  }, [profile]);

  const handleLogout = () => {
    const leaverUrl = getLeaverUrl();
    if (leaverUrl) Cookies.set('redirectLogout', leaverUrl);
    const handleSignOut = async () => {
      signOut().then(() => {
        GaAnalytics.sendEvent('logout');
        Cookies.remove('redirectLogout');
      }).then(() => {
        window.open(`https://${process.env.REACT_APP_SSO_COGNITO_DOMAIN}/logout?client_id=${process.env.REACT_APP_SSO_COGNITO_CLIENT_ID}&logout_uri=${process.env.REACT_APP_SSO_COGNITO_REDIRECT_URI_LOGOUT}&response_type=token`, '_self');
      });
    };
    handleSignOut();
  };

  return (
    <div className="h-100">
      <div className="d-flex align-items-center h-100">
        <div className="mx-auto login-box">
          <div className="card">
            <CardHeader />
            <div className="card-body">
              <h5 className="card-title text-center py-1">Logout</h5>
              <p className="card-text">Esci e ritorna alla schermata di login principale</p>
              <div className="form-group mt-5 d-flex align-items-center justify-content-around">
                <button
                  className="btn btn-primary mt-2 mb-5"
                  onClick={() => {
                    handleLogout();
                  }}
                >
                  Logout
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
